module.exports = __webpack_public_path__ + "static/media/selected_tire.e20b780a.svg";